import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router,  ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { QueryStringParameter, DynamicPage,User} from '../../models/data.types';
import { DynamicPageComponent } from '../../helpers/dynamicPage';
import { DynamicPageDirective } from '../../directives/index';
import { Headers } from '@angular/http';
import { ToastrModule, ToastrService } from 'ngx-toastr';

import { Observable } from 'rxjs/Observable';

@Component({
   selector: 'app-dashboard',
   entryComponents: [DynamicPageComponent],
   templateUrl: './dashboard.component.html'
})

export class DashboardComponent {

    sub: any;
    pagename: string;
    title: string;
    page: DynamicPage = new DynamicPage();

    @ViewChild(DynamicPageDirective) dynamicPage: DynamicPageDirective;

    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private apiService : ApiService,
                private toastr: ToastrService,
                private titleService: Title) {  }
    
    onEnterSearch(value: string) {
        //this.router.navigateByUrl('/Dashboard/Scheid/Portals/Vitwatch-Portals?title='+value);
        this.router.navigate(['/Dashboard/Scheid/Portals/Vitwatch-Portals'], { queryParams: {title:value, showfavs:0} });
    }

    canDeactivate(): Observable<boolean> | boolean {
      if (localStorage["pageLocked"] === "1") {
         this.toastr.info('Please save your changes before changing the schedule ', null, { timeOut: 2000, progressBar: true, progressAnimation: 'increasing',positionClass: "toast-top-right"});
         return false;
      }
      return true;
   } 

    ngOnInit() {

      this.sub = this.route.params.subscribe(params => {

        if (params['id'] == null) {
          this.pagename = 'SystemDashboardPage';
        }
        else {
          this.pagename = params['id'];
        }

        let body = JSON.parse('{"route": "'+this.pagename +'"}');

        let dynamicPageComponent = new DynamicPageComponent(this.route,this.apiService,this.titleService);
        dynamicPageComponent.LoadDynamicPage(this.pagename,this.dynamicPage,true).then(x => this.title = x);
  
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.component.ts